const loginInitialValues = {
    Email: '',
    Senha: '',
    PermanecerConectado: true,
};
export default loginInitialValues;
